import classnames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { BaseLinkPanelLabels, BaseLinkPanelText } from '@eika/link-panel/src/LinkPanelTypes';
import { Labels, PanelArrow, TextContent } from '@eika/link-panel/src/components';

import './ButtonPanelCard.scss';

type ButtonPanelCardProps = {
    id: string;
    labels?: BaseLinkPanelLabels;
    isInformation?: boolean;
    ariaLabel?: string;
    icon: IconTypes;
    onClick: () => void;
    actionIcon?: IconTypes;
} & BaseLinkPanelText &
    Omit<React.PropsWithoutRef<JSX.IntrinsicElements['button']>, 'id' | 'onClick'>;

const ButtonPanelCard: React.FC<ButtonPanelCardProps> = ({
    id,
    onClick,
    title,
    textOne,
    textTwo,
    textThree,
    icon,
    labels,
    ariaLabel,
    isInformation,
    className,
    actionIcon,
    ...rest
}) => {
    const textContent = { title, textOne, textTwo, textThree };
    const hasTextContent = textOne || labels || textTwo || textThree;
    return (
        <article
            className={classnames(
                'sgw-link-card button-panel',
                { information: isInformation },
                { 'align-center': !hasTextContent },
                className,
            )}
            aria-labelledby={id}
            key={rest.key}
        >
            <button type="button" className="sgw-link-card__link" onClick={onClick} aria-label={ariaLabel} {...rest}>
                <Labels className="sgw-link-card__labels" labels={labels} />
                <span className="card-icon__wrapper">
                    <Icon type={icon} className="card-icon" />
                </span>
                <TextContent id={id} prefixClass="sgw-link-card" {...textContent} />
                <PanelArrow icon={actionIcon} className="sgw-link-card__arrow-wrapper" />
            </button>
        </article>
    );
};

export default ButtonPanelCard;
